'use client';

import type { ProductCardSkeletonProps } from '../types';

export default function ProductCardSkeleton({ variant }: ProductCardSkeletonProps) {
  if (variant === 'list') {
    return (
      <div className="flex items-start gap-4 p-3 animate-pulse">
        <div className="w-20 h-20 bg-[#F8F8F8] rounded-[4px] flex-shrink-0" />
        <div className="flex-1 flex flex-col gap-[6px] pt-1">
          <div className="h-[14px] bg-[#F8F8F8] rounded-[4px] w-[65px]" />
          <div className="h-[14px] bg-[#F8F8F8] rounded-[4px] w-full" />
          <div className="h-[14px] bg-[#F8F8F8] rounded-[4px] w-[203px]" />
        </div>
      </div>
    );
  }

  // Grid skeleton — matches Figma "Frame 1000002448"
  return (
    <div className="flex flex-col">
      {/* Badge + heart row */}
      <div className="flex h-[48px] items-center justify-between px-[8px]">
        <div className="w-[61px] h-[24px] bg-[#F8F8F8] rounded-[4px]" />
        <div className="w-[24px] h-[24px] bg-[#F8F8F8] rounded-full" />
      </div>
      {/* Image placeholder */}
      <div className="flex h-[188px] items-center justify-center">
        <div className="w-[188px] h-[188px] bg-[#F8F8F8] rounded-[4px]" />
      </div>
      {/* Info section */}
      <div className="flex flex-col gap-[6px] border-t border-[#F8F8F8] pl-[16px] pt-[13px] pb-[12px]">
        {/* Brand */}
        <div className="w-[65px] h-[14px] bg-[#F8F8F8] rounded-[4px]" />
        {/* Title lines */}
        <div className="flex flex-col gap-[4px]">
          <div className="h-[14px] bg-[#F8F8F8] rounded-[4px] w-full max-w-[254px]" />
          <div className="h-[14px] bg-[#F8F8F8] rounded-[4px] w-[203px]" />
        </div>
      </div>
    </div>
  );
}
